import { render, staticRenderFns } from "./PeriodoPerfil.vue?vue&type=template&id=19ad2158&scoped=true"
import script from "./PeriodoPerfil.vue?vue&type=script&lang=js"
export * from "./PeriodoPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ad2158",
  null
  
)

export default component.exports